import useYardActionEvents from "@hsl/core/hooks/useYardAnalyticsEvents";

import useExplorerStore from "../../store/store";

const ContactUsCTA = () => {
    const contactURL = useExplorerStore((store) => store.config.contactURL);
    const usertypeId = useExplorerStore((state) => state.config.usertypeId);
    const isPrivate = [64, 65, 133, 149, 150, 151].includes(usertypeId);
    const { clickLinkEvent } = useYardActionEvents();

    return isPrivate ? (
        <></>
    ) : (
        <div className="sticky top-0 z-10 hidden lg:block">
            <a
                target="_blank"
                href={contactURL}
                className="bg-dark-blue hover:bg-dark-blue/90 absolute -right-8 top-0 z-50 -mb-[3rem] mt-[12.5rem] w-max -rotate-90 transform px-4 py-2 text-white transition"
                onClick={() =>
                    clickLinkEvent({
                        url: contactURL,
                        name: "Contact us Fund Centre",
                    })
                }
                rel="noreferrer"
            >
                Contact us
            </a>
        </div>
    );
};

export default ContactUsCTA;
